import React from "react";
import PropTypes from "prop-types";
import Button from "material-ui/Button";
import SendIcon from "material-ui-icons/Send";
import "./FetchButton.css";

const FetchButton = props => {
  const { disabled, onClick, text, size } = props;
  return (
    <Button
      variant="raised"
      color="primary"
      className="fetch-button"
      disabled={disabled}
      onClick={onClick}
      size={size || "large"}
    >
      {text}
      <SendIcon />
    </Button>
  );
};

FetchButton.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired
};

export default FetchButton;



// WEBPACK FOOTER //
// ./src/components/FetchButton/FetchButton.js